const state = {
  meetingPlanChangesTriggeredByAutoSync: false
}
const mutations = {
  setMeetingPlanChangesTriggeredByAutoSync(state, value) {
    state.meetingPlanChangesTriggeredByAutoSync = value;
  }
}
const getters = {
  meetingPlanChangesTriggeredByAutoSync: (state) => state.meetingPlanChangesTriggeredByAutoSync,
}
const actions = {}
export default {
  state,
  mutations,
  getters,
  actions,
}